import React, { FormEvent, useState } from "react";
import {
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Typography,
} from "@mui/material";
import styles from "./ContatoForm.module.css";
import styles_button from "../../../styles/Button.module.css";
import { useCadastro } from "../../../resources/CadastroProvider";
import TelefoneField from "../../atoms/TelefoneField/TelefoneField";

interface Props {
  edit?: boolean;
}

const ContatoForm = ({ edit }: Props) => {
  const {
    steps,
    contactData,
    setStepCompletedAtIndex,
    setContactData,
    handlePrevStep,
    handleNextStep,
    handleUpdateUser,
    loadingUpdate,
  } = useCadastro();

  const [mensagem, setMensagem] = useState<string>("");
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleEmailInstitucionalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setContactData({ ...contactData, email_institucional: value });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: keyof typeof contactData,
  ) => {
    const value =
      e.target.type === "checkbox"
        ? (e.target as HTMLInputElement).checked
        : e.target.value;

    setContactData({
      ...contactData,
      [field]: value,
    });
  };

  const isValidEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const indexStep = steps.findIndex(
      (step) => step.label === "Dados de Contato",
    );

    setMensagem("");
    setErrors({});

    if (indexStep !== -1) {
      setStepCompletedAtIndex(indexStep, false);
    }

    const validationErrors: Record<string, string> = {};

    if (
      !contactData.telefone_celular ||
      contactData.telefone_celular.length < 14
    ) {
      validationErrors.telefone_celular = "Informe um telefone celular válido.";
    }

    if (
      contactData.telefone_residencial &&
      contactData.telefone_residencial.length < 13
    ) {
      validationErrors.telefone_residencial = "Informe um telefone residencial válido.";
    }

    if (
      contactData.telefone_institucional &&
      contactData.telefone_institucional.length < 13
    ) {
      validationErrors.telefone_institucional = "Informe um telefone institucional válido.";
    }

    if (
      contactData.email_institucional &&
      !isValidEmail(contactData.email_institucional)
    ) {
      validationErrors.email_institucional = "Informe um e-mail institucional válido.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (edit) {
      handleUpdateUser(3);

    } else {

      if (indexStep !== -1) {
        setStepCompletedAtIndex(indexStep, true);
      }

      setMensagem("");
      handleNextStep();
    }
  };

  return (
    <div className={styles.container} data-testid="cadastro-contato-form">
      <div className={styles.card}>
        <div className={styles.title}>
          Dados de Contato
        </div>
        <div className={styles.message}>
          {mensagem && <Typography color="error">{mensagem}</Typography>}
        </div>
        <div className={styles.lineInput}>
          <div className={styles.inputGroup}>
            <label className={styles.titleInput}>
              Telefone Celular *
            </label>
            <TelefoneField
              label=""
              required
              customClass={styles.input}
              fullWidth
              value={contactData.telefone_celular || ""}
              onChange={(value) =>
                setContactData({
                  ...contactData,
                  telefone_celular: value,
                })
              }
              error={!!errors.telefone_celular}
              helperText={errors.telefone_celular}
            />
          </div>

          <div className={styles.inputGroupSwitch}>
            <label className={styles.titleInputSwitch}>
              Este número possui WhatsApp?
            </label>
            <FormControlLabel
              control={
                <Switch
                  checked={contactData.possui_whatsapp || false}
                  onChange={(e) => handleChange(e, "possui_whatsapp")}
                  name="possui_whatsapp"
                  color="primary"
                />
              }
              label=""
            />
          </div>
        </div>
        <div className={styles.lineInput}>
            
          <div className={styles.inputGroup}>
            <label className={styles.titleInput}>
              Telefone Fixo
            </label>
            <TelefoneField
              fixo
              label=""
              customClass={styles.input}
              fullWidth
              value={contactData.telefone_residencial || ""}
              onChange={(value) =>
                setContactData({
                  ...contactData,
                  telefone_residencial: value,
                })
              }
              error={!!errors.telefone_residencial}
              helperText={errors.telefone_residencial}
            />
          </div>
          <div className={styles.inputGroup}>
            <label className={styles.titleInput}>
              Telefone Institucional
            </label>
            <TelefoneField
              fixo
              label=""
              customClass={styles.input}
              fullWidth
              value={contactData.telefone_institucional || ""}
              onChange={(value) =>
                setContactData({
                  ...contactData,
                  telefone_institucional: value,
                })
              }
              error={!!errors.telefone_institucional}
              helperText={errors.telefone_institucional}
            />
          </div>
        </div>   
        <div>
          <div className={styles.inputGroup}>
            <label className={styles.titleInput}>
              E-mail Institucional
            </label>
            <TextField
              size="small"
              variant="standard"
              autoFocus={false}
              fullWidth
              data-testid="nome"
              required
              value={contactData.email_institucional}
              onChange={handleEmailInstitucionalChange}
              error={!!errors.email_institucional}
              helperText={errors.email_institucional}
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{
                shrink: false,
              }}
              InputProps={{
                className: styles.input,
                disableUnderline: true,
              }}
            />
          </div>
        </div>
        {!edit ? (
          <div className={styles.buttonContainer}>
            <Button 
              variant="contained" // Use 'contained' para botÃµes com cor de fundo
              sx={{
                width: { xs: '136px', sm: '168px' }, 
                height: { xs: '42px', sm: '46px' },
                paddingY: 2, // 8px (MUI spacing unit)
                paddingX: 6, // 24px (MUI spacing unit)
                backgroundColor: '#2C3D8F',
                color: 'white',
                fontWeight: 500, 
                textAlign: 'center', 
                borderRadius: '9999px',
                '&:hover': {
                  backgroundColor: '#4556A8',
                  boxShadow: 'none', 
                },
                transition: 'background-color 200ms ease-in-out', 
              }}
              color="primary"
              onClick={handlePrevStep}
            >
              Voltar
            </Button>
            <Button
              variant="contained"
              sx={{
                width: { xs: '136px', sm: '168px' }, 
                height: { xs: '42px', sm: '46px' },
                paddingY: 2, // 8px (MUI spacing unit)
                paddingX: 6, // 24px (MUI spacing unit)
                backgroundColor: '#5A81FA',
                color: 'white',
                fontWeight: 500, 
                textAlign: 'center', 
                borderRadius: '9999px',
                '&:hover': {
                  backgroundColor: '#7A9BFB',
                  boxShadow: 'none', 
                },
                transition: 'background-color 200ms ease-in-out', 
              }}
              className={styles.nextbutton}
              onClick={handleSubmit}
            >
              Próximo
            </Button>
          </div>
        ) : (
          <Button
            variant="contained"
            sx={{
              width: { xs: '136px', sm: '168px' }, 
              height: { xs: '42px', sm: '46px' },
              paddingY: 1, // 8px (MUI spacing unit)
              paddingX: 6, // 24px (MUI spacing unit)
              backgroundColor: '#5A81FA',
              color: 'white',
              fontWeight: 500, 
              textAlign: 'center', 
              borderRadius: '9999px',
              '&:hover': {
                backgroundColor: '#7A9BFB',
                boxShadow: 'none', 
              },
              transition: 'background-color 200ms ease-in-out', 
            }}
            disabled={loadingUpdate} 
            className={`${styles_button.buttonPrimary} ${(loadingUpdate) ? styles_button.buttonLoad : ''} `}
            onClick={handleSubmit}
          >
            {loadingUpdate ? (
              <>
              <div className={styles_button.spinner}></div>
              <span>Salvando...</span>
              </>
            ) : (
            <span>Salvar</span>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ContatoForm;

/* 

inputs antigos

<div className={styles.card}>
  <Typography variant="h4">Dados de Contato</Typography>
  <div className={styles.divContato}>
    {mensagem && <Typography color="error">{mensagem}</Typography>}
    <TelefoneField
      fixo
      label="Telefone Fixo"
      className={styles.telefoneFixo}
      value={contactData.telefone_residencial || ""}
      onChange={(value) =>
        setContactData({
          ...contactData,
          telefone_residencial: value,
        })
      }
    />
    <TelefoneField
      label="Telefone Celular"
      required
      className={styles.telefoneCelular}
      value={contactData.telefone_celular || ""}
      onChange={(value) =>
        setContactData({
          ...contactData,
          telefone_celular: value,
        })
      }
    />
    <FormControlLabel
      control={
        <Switch
          checked={contactData.possui_whatsapp || false}
          onChange={(e) => handleChange(e, "possui_whatsapp")}
          name="possui_whatsapp"
          color="primary"
        />
      }
      label="Este nÃºmero possui WhatsApp?"
    />
    <TelefoneField
      fixo
      label="Telefone Institucional"
      className={styles.telefoneInstitucional}
      value={contactData.telefone_institucional || ""}
      onChange={(value) =>
        setContactData({
          ...contactData,
          telefone_institucional: value,
        })
      }
    />
    <TextField
      variant="standard"
      label="E-mail Institucional"
      className={styles.emailInstitucional}
      value={contactData.email_institucional || ""}
      onChange={(e) => handleChange(e, "email_institucional")}
    />
  </div>
</div>
{!edit && (
  <div className={styles.buttoncontainer}>
    <Button className={styles.backbutton} onClick={handlePrevStep}>
      Voltar
    </Button>
    <Button
      variant="contained"
      color="primary"
      className={styles.nextbutton}
      onClick={handleSubmit}
    >
      Próximo
    </Button>
  </div>
)}

*/

